import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class EventoProvider {
  baseAntigaUrl = environment.API_ANTIGA_URL;
  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) {
    console.log('Hello EventoProvider Provider');
  }

  getProgamacao(mes) {
    return this.http.post<any>(this.baseAntigaUrl + '/programacao/' + mes, {}).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getById(id) {
    return this.http.post<any>(this.baseUrl + '/evento-api/get-evento-by-id', { id: id }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  icsCalendar(id) {
    return this.http
      .get<any>(this.baseUrl + '/evento/ics/' + id, {
        headers: {
          'Content-Type': 'text/calendar; charset=utf-8',
          'Content-Disposition': 'attachment; filename=invite.ics',
        },
      })
      .map((data) => {
        return data;
      });
  }

  projetosPessoa(idPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/evento/projetos-pessoa', {
        idPessoa: idPessoa,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  historico(filtro, idPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/historico', {
        filtro: filtro,
        idPessoa: idPessoa,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getBoletim(idEvento) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/get-boletim', {
        idEvento: idEvento,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  public encodeObjToUrl(obj: any): string {
    let str = JSON.stringify(obj);

    str = str.replace(/[\u007F-\uFFFF]/g, function (chr) {
      return '\\u' + ('0000' + chr.charCodeAt(0).toString(16)).substr(-4);
    });

    const url = btoa(str);
    return encodeURIComponent(url);
  }

  getTipos() {
    return this.http.get<any>(this.baseUrl + '/evento-api/get-tipos').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getPresencas(filtro, pag, idEvento, idEncontro) {
    let params = new HttpParams()
      .set('page', pag.currentPage)
      .set('per-page', '10')
      .set('q', filtro.q)
      .set('idEvento', idEvento)
      .set('idEncontro', idEncontro);

    return this.http
      .get<any>(this.baseUrl + '/evento-api/get-presencas', {
        observe: 'response',
        params: params,
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          inscritos: data.body,
          pagination: pag,
        };
      });
  }

  getReposicao(filtro, pag, idEncontro) {
    let params = new HttpParams()
      .set('page', pag.currentPage)
      .set('per-page', '10')
      .set('busca', filtro.q)
      .set('idEncontro', idEncontro);

    return this.http
      .get<any>(this.baseUrl + '/evento-api/get-reposicao', {
        observe: 'response',
        params: params,
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          inscritos: data.body,
          pagination: pag,
        };
      });
  }

  getPresencasAvaliacao(filtro, pag, idEvento, idEncontro, idEnsinoAvaliacao) {
    let params = new HttpParams()
      .set('page', pag.currentPage)
      .set('per-page', '10')
      .set('q', filtro.q)
      .set('idEvento', idEvento)
      .set('idEncontro', idEncontro)
      .set('idEnsinoAvaliacao', idEnsinoAvaliacao);

    return this.http
      .get<any>(this.baseUrl + '/evento/get-presencas-avaliacao', {
        observe: 'response',
        params: params,
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          inscritos: data.body,
          pagination: pag,
        };
      });
  }

  getInscritos(filtro, pag, idEvento) {
    let params = new HttpParams()
      .set('page', pag.currentPage)
      .set('per-page', '10')
      .set('q', filtro.q)
      .set('idEvento', idEvento);

    return this.http
      .get<any>(this.baseUrl + '/evento/lista-inscritos', {
        observe: 'response',
        params: params,
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          inscritos: data.body,
          pagination: pag,
        };
      });
  }

  getInscritosFiltro(filtro, pag, idEvento, s) {
    let params = new HttpParams()
      .set('expand', 'encontroBasic')
      .set('page', pag.currentPage)
      .set('per-page', '10')
      .set('q', filtro.q)
      .set('s', 'true')
      .set('idEvento', idEvento);

    return this.http
      .get<any>(this.baseUrl + '/evento/lista-inscritos-filtro', {
        observe: 'response',
        params: params,
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          inscritos: data.body,
          pagination: pag,
        };
      });
  }

  getDadosInscricao(idInscricao) {
    return this.http.get<any>(this.baseUrl + '/evento/dados-inscricao?idInscricao=' + idInscricao).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  checkin(idEncontro, idInscricao, idPessoa, idPessoaFamiliarCheckIn, idPresenca, obsCheckIn) {
    return this.http
      .post<any>(this.baseUrl + '/evento/check-in', {
        idEncontro: idEncontro,
        idInscricao: idInscricao,
        idPessoa: idPessoa,
        idPessoaFamiliarCheckIn: idPessoaFamiliarCheckIn,
        idPresenca: idPresenca,
        obsCheckIn: obsCheckIn,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  checkout(idEncontro, idInscricao, idPessoa, idPessoaFamiliarCheckOut, idPresenca, obsCheckOut) {
    return this.http
      .post<any>(this.baseUrl + '/evento/check-out', {
        idEncontro: idEncontro,
        idInscricao: idInscricao,
        idPessoa: idPessoa,
        idPessoaFamiliarCheckOut: idPessoaFamiliarCheckOut,
        idPresenca: idPresenca,
        obsCheckOut: obsCheckOut,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarPresenca(presenca) {
    return this.http
      .post<any>(this.baseUrl + '/evento/salvar-presenca', {
        idEventoEncontroPresenca: presenca.idEventoEncontroPresenca,
        idPessoa: presenca.idPessoa,
        idEventoEncontro: presenca.idEventoEncontro,
        idEncontro: presenca.idEncontro,
        idEventoInscricao: presenca.idEventoInscricao,
        idEvento: presenca.idEvento,
        valor: presenca.valor,
        aproveitamento: presenca.aproveitamento,
        presenca: presenca.presenca,
        observacao: presenca.observacao,

        nota_avaliacao: presenca.nota_avaliacao,
        data_avaliacao: presenca.data_avaliacao,
        idEnsinoAvaliacaoEventoPresenca: presenca.idEnsinoAvaliacaoEventoPresenca,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getEncarregados(filtro, pag, idEventoEncontro) {
    return this.http
      .get<any>(this.baseUrl + '/evento-api/buscar-encarregados', {
        observe: 'response',
        params: {
          expand: 'pessoa,pessoaFuncoesEspec',
          page: pag.currentPage,
          'per-page': '10',
          q: filtro.q,
          idEventoEncontro: idEventoEncontro,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          encarregados: data.body,
          pagination: pag,
        };
      });
  }

  getEventos(tipoEvento) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/get-eventos', {
        tipoEvento: tipoEvento,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getEventosInscrito(tipoEvento) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/get-eventos-inscrito', {
        tipoEvento: tipoEvento,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getLayoutAula(idAula, idEvento) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/get-layout-aula', {
        idAula: idAula,
        idEvento: idEvento,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getNotasEncontro(idEncontro) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/get-notas-encontro', {
        idEncontro: idEncontro,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  verificaInscricaoPessoa(idEvento) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/verifica-inscricao-pessoa', {
        idEvento: idEvento,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getNotasParticipante(idPessoa, idEncontro) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/get-notas-participante', {
        idPessoa: idPessoa,
        idEncontro: idEncontro,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarNotasParticipante(idEncontro, idPessoa, atividades) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/salvar-notas-participante', {
        idEncontro: idEncontro,
        idPessoa: idPessoa,
        atividades: atividades,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  salvarPresencaParticipante(pessoa) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/salvar-presenca-participante', {
        pessoa: pessoa,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  inscreverPessoaEvento(idEvento) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/inscrever-pessoa-evento', {
        idEvento: idEvento,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  verificaAdmin(idEncontro) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/verifica-admin', {
        idEncontro: idEncontro,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  resumoEnquete(idInscricao) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/resumo-enquete', {
        idInscricao: idInscricao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  buscarServicosInscricao(idInscricao) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/buscar-servicos-inscricao', {
        idInscricao: idInscricao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  buscaDetalhesPessoa(idEvento) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/buscar-detalhes-pessoa', {
        idEvento: idEvento,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getLotesByIdInscricao(idInscricao) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/get-lotes-by-id-inscricao', {
        idInscricao: idInscricao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getServicosByIdInscricao(idInscricao) {
    return this.http
      .get<any>(this.baseUrl + '/evento-api/get-servicos-by-id-inscricao?idInscricao=' + idInscricao)
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  retirarServico(idInscricaoxservico) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/retirar-servico', {
        idInscricaoxservico: idInscricaoxservico,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  retirarTodosServicos(idInscricao) {
    return this.http
      .get<any>(this.baseUrl + '/evento-api/retirar-todos-servicos?idInscricao=' + idInscricao)
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getDetalhesPresenca(idInscricao, idPresenca) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/get-detalhes-presenca', {
        idInscricao: idInscricao,
        idPresenca: idPresenca,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  checkInAvulso(idPresenca, qntChecks) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/check-in-avulso', {
        idPresenca: idPresenca,
        qntChecks: qntChecks,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getPessoasReposicao(idInscricao) {
    return this.http
      .get<any>(this.baseUrl + '/evento-api/get-pessoas-reposicao?idInscricao=' + idInscricao)
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getEnsinosReposicao(idAula, idModulo, idEvento) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/get-ensinos-reposicao', {
        idAula: idAula,
        idModulo: idModulo,
        idEvento: idEvento,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getInscritosEnsino(idEnsino, ensinoReposicao) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/get-inscritos-ensino', {
        idEnsino: idEnsino,
        ensinoReposicao: ensinoReposicao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  validaPessoaReposicao(idAula, idPessoa, idEvento) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/valida-pessoa-reposicao', {
        idAula: idAula,
        idPessoa: idPessoa,
        idEvento: idEvento,
      })
      .map((data) => {
        return data;
      });
  }

  salvarReposicao(idEnsino, idPessoa, idEncontro, idAula) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/salvar-reposicao', {
        idEnsino: idEnsino,
        idPessoa: idPessoa,
        idEncontro: idEncontro,
        idAula: idAula,
      })
      .map((data) => {
        return data;
      });
  }

  verificaCheckIn(idEvento, idEncontro) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/verifica-checkin', {
        idEvento: idEvento,
        idEncontro: idEncontro,
      })
      .map((data) => {
        return data;
      });
  }

  salvarPresencaCode(uuid, idEncontro) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/salvar-presenca-code', {
        uuid: uuid,
        idEncontro: idEncontro,
      })
      .map((data) => {
        return data;
      });
  }

  getEncontrosPassados(uuid) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/get-encontros-passados', {
        uuid: uuid,
      })
      .map((data) => {
        return data;
      });
  }

  quantidadeInscritos(idEvento) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/quantidade-inscritos', { idEvento: idEvento })
      .map((data) => {
        return data;
      });
  }

  getEventosEnsinosCertificados(idPessoa) {
    return this.http
      .get<any>(this.baseUrl + '/evento-api/get-eventos-ensinos-certificados', {
        observe: 'response',
        params: { idPessoa: idPessoa },
      })
      .map((data) => {
        if (data.body) {
          return data.body;
        } else {
          return false;
        }
      });
  }

  quantidadeCheckin(idEvento, idEncontro) {
    return this.http
      .post<any>(this.baseUrl + '/evento-api/quantidade-checkin', {
        idEvento: idEvento,
        idEncontro: idEncontro,
      })
      .map((data) => {
        return data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/evento/evento.ts